<template>
  <div id="without-user-layout" :class="[needBlurBackground ? 'modalBlur' : '']">
    <router-view />
  </div>
</template>

<script>
import GenericModal from '@/components/shared/elements/modal/GenericModal';

export default {
  name: 'WithoutUserLayout',
  props: {
    needBlurBackground: {
      type: Boolean,
    },
  },
  components: {},
  data: () => ({}),
  created() {
    this.watchGoogleTranslator();
  },
  computed: {},
  methods: {
    watchGoogleTranslator() {
      document.addEventListener(
        'DOMSubtreeModified',
        this.googleTranslatorHandler,
        true,
      );
    },
    removeGoogleTranslatorListener() {
      document.removeEventListener(
        'DOMSubtreeModified',
        this.googleTranslatorHandler,
      );
    },
    googleTranslatorHandler(e) {
      setTimeout(() => {
        const htmlClassList = [
          ...document.getElementsByTagName('html')[0].classList,
        ];
        const pageIsTranslated =
          htmlClassList.includes('translated-ltr') ||
          htmlClassList.includes('translated-rtl');
        if (!pageIsTranslated) {
          this.translateModalWasShown = false;
        }
        if (
          e.target.tagName === 'HTML' &&
          window.google &&
          e.target.className.match('translated')
        ) {
          this.translateModalWasShown = true;
          this.showTranslatorModal();
        } else if (pageIsTranslated && this.translateModalWasShown == false) {
          this.translateModalWasShown = true;
          this.showTranslatorModal();
        }
      }, 500);
    },
    showTranslatorModal() {
      this.$eventBus.showModal({
        bind: {
          is: GenericModal,
          hasExit: false,
          titleText: this.$t('app.listeners.googleTranslate.title'),
          description: this.$t('app.listeners.googleTranslate.description'),
          okText: this.$t('app.listeners.googleTranslate.okText'),
          okAction: () => {
            this.$eventBus.closeModal();
          },
        },
      });
    },
  },
};
</script>

<style lang="scss">
/*
 * Custom styles
 */
@import "@/assets/css/global.scss";
</style>
